import React from "react";
import { ArrowUpNarrowWide, ArrowDownWideNarrow } from "lucide-react";
import { Button } from "../ui/button";
import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from "../ui/select";

// Sort field dropdown (only shown when >1 field option) + Asc/Desc toggle button.
export function SortControl({ fields, sortBy, onSortByChange, sortDir, onSortDirChange, testId = "sort-control" }) {
  return (
    <div className="flex items-center gap-1.5" data-testid={testId}>
      {fields.length > 1 && (
        <Select value={sortBy} onValueChange={onSortByChange}>
          <SelectTrigger className="w-40" data-testid={`${testId}-field-select`}>
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            {fields.map((f) => (
              <SelectItem key={f.value} value={f.value}>{f.label}</SelectItem>
            ))}
          </SelectContent>
        </Select>
      )}
      <Button
        type="button" variant="outline" size="icon"
        title={sortDir === "asc" ? "Ascending" : "Descending"}
        onClick={() => onSortDirChange(sortDir === "asc" ? "desc" : "asc")}
        data-testid={`${testId}-direction-toggle`}
      >
        {sortDir === "asc" ? <ArrowUpNarrowWide size={16} strokeWidth={1.5} /> : <ArrowDownWideNarrow size={16} strokeWidth={1.5} />}
      </Button>
    </div>
  );
}
